import { Directive, ElementRef, inject, OnInit, Renderer2 } from '@angular/core';

@Directive({
  selector: '[id]',
})
export class DataIdBinderDirective implements OnInit {
  private readonly elRef = inject<ElementRef<HTMLElement>>(ElementRef);
  private readonly renderer = inject<Renderer2>(Renderer2);

  readonly dataAttrsIds = [
    'data-test-id',
    'data-tour-id',
  ];

  ngOnInit() {
    this.bindDataIds();
  }


  private bindDataIds(): void {
    this.dataAttrsIds.forEach(attr => this.renderer.setAttribute(
      this.elRef.nativeElement,
      attr,
      this.elRef.nativeElement.id
    ));
  }
}
